module.exports = __webpack_public_path__ + "static/media/arrowDownIcon.56c46aa8.svg";